export const sidebarFBIcon = `
<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle opacity="0.5" cx="17" cy="17" r="17" fill="#FF53FF"/>
<path d="M18.1971 25V18.1689H20.5664L20.9186 15.4943H18.1971V13.7907C18.1971 13.0189 18.4182 12.4905 19.557 12.4905H21V10.106C20.2979 10.0328 19.5922 9.99747 18.886 10.0001C16.7918 10.0001 15.3539 11.2437 15.3539 13.5265V15.4893H13V18.1639H15.359V25H18.1971Z" fill="white"/>
</svg>
`;
